import { useData } from '../../data/hooks';
import { useNow } from '../../ui/useNow';
import type { TileDef, TileSize } from '../registry';

function DateTile({ size }: { size: TileSize; config: unknown }) {
  const { tz } = useData();
  const now = useNow();
  const parts = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: tz,
  }).formatToParts(now);
  const month = parts.find((p) => p.type === 'month')?.value ?? '';
  const day = parts.find((p) => p.type === 'day')?.value ?? '';
  const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: tz }).format(now);
  const full = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeZone: tz }).format(now);
  return (
    <div>
      <p className="text-[36px] leading-tight">
        <span className="font-semibold">{month}</span>{' '}
        <span className="font-mono tabular-nums">{day}</span>
      </p>
      <p className="text-sm text-muted">{size === 'wide' ? full : weekday}</p>
    </div>
  );
}

export const dateTile: TileDef = {
  type: 'today.date',
  moduleId: 'today',
  title: 'Date',
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  Component: DateTile,
};
